import React from "react";
import * as ST from "./styled";
import SubMenuItem from "../../SubMenuItem";
import {Link} from "@mui/material";
import SubMenuItemText from "../../SubMenuItemText";
import DataHeaderType from "../../../../../Types/DataHeaderType";

interface SubmenuPropsLlv3 {
	items: DataHeaderType[]
}

const SubMenuLvl3: React.FC<SubmenuPropsLlv3> = ({items}) => {
	return (
		<ST.SubMenuItemsStyledLvl3>
			{items.map((item) => (
				<SubMenuItem
					key={item.id}
				>
					<Link href={item.path} sx={{textDecoration: "none"}}>
						<SubMenuItemText text={item.name} />
					</Link>
				</SubMenuItem>
			))}
		</ST.SubMenuItemsStyledLvl3>
	)
}

export default SubMenuLvl3